import * as constants from '../constants';

const initialState = [];

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getUsersPhyto.success: {
            return action.payload;
        }

        case constants.getUsersPhyto.error: {
            return [];
        }

        case constants.getUsersPhyto.try: {
            return initialState;
        }

        default:
            return state;
    }
}